import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { NumberInputComponent } from '@navstation-portal/shared/ui/components';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshorePositionAndWeatherEvents,
  OffshorePositionAndWeatherFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { LatLongTemplateComponent } from '../../../../shared/lat-long-template/lat-long-template.component';

@Component({
  selector: 're-position-and-logistics',
  templateUrl: './position-and-logistics.component.html',
  imports: [
    NumberInputComponent,
    LatLongTemplateComponent,
    FormsModule,
    IsVisibleDirective,
  ],
})
export class PositionAndLogisticsComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'positionAndWeather';
  sectionId = 'positionAndLogistics';
  events = injectDispatch(offshorePositionAndWeatherEvents);
  positionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
